import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';
import {
  Product,
  UiLandingProductCardBioderma
} from '@/fo/ui/landing/product-card/bioderma';
import { addLandingProductToCart } from '@/fo/util/landing-prices';

import { styles } from './StepsProducts.styles';

export interface StepsProductsProps {
  stepsProducts: Product[];
  className?: string;
}

export function StepsProducts({
  stepsProducts,
  className
}: StepsProductsProps) {
  const slots = styles();

  return (
    <div
      className={slots.base({ className })}
      id="routine-products"
    >
      <div className={slots.content()}>
        <h2 className={slots.title()}>Уход для кожи, склонной к акне​</h2>
        <UiKitCarouselBase
          className={slots.carousel()}
          loop={false}
          arrowPrevClass={slots.arrowPrev()}
          arrowNextClass={slots.arrowNext()}
          alwaysShowArrows
        >
          {stepsProducts.map((product, index) => (
            <div
              key={product.sku}
              className={`${slots.product()} ${index === 1 ? 'lg:ml-6' : ''}`}
            >
              <div className={slots.step()}>
                {index === 0 && (
                  <>
                    <div className={slots.stepNumber()}>шаг 1</div>
                    <div className={slots.stepValue()}>очищение</div>
                  </>
                )}
                {index === 1 && (
                  <>
                    <div className={`${slots.stepNumber()} lg:hidden`}>
                      шаг 2
                    </div>
                    <div className={`${slots.stepValue()} lg:hidden`}>уход</div>
                  </>
                )}
                {index === 2 && (
                  <>
                    <div className={`${slots.stepNumber()} max-lg:hidden`}>
                      шаг 2
                    </div>
                    <div className={`${slots.stepValue()} max-lg:hidden`}>
                      уход
                    </div>
                  </>
                )}
              </div>
              <UiLandingProductCardBioderma
                className={slots.productCard()}
                classNameImageWrapper={slots.imageWrapper()}
                classNameList="gap-1 lg:gap-1 md:min-h-[135px]"
                product={product}
                positionIndex={index}
                variant="default"
                listItemVariant="dot"
                onAddToCart={() => addLandingProductToCart(product)}
              />
            </div>
          ))}
        </UiKitCarouselBase>
      </div>
    </div>
  );
}
